import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { handleCursos } from '../../api/curso';
import { retrieveToken } from '../../hooks/use-token';

export const getUsers = createAsyncThunk(
    'usersSlice/getUsers',
    async () => {

      const tokenApi = retrieveToken();
      return await handleCursos(tokenApi);
      
    }
);

const initialState = {
    status: null,
    data: []
}

const usersSlice = createSlice({
    name: 'usersSlice',
    initialState,
    extraReducers: {
      [getUsers.pending]: (state) => {
        state.status = 'Pending';
      },
      [getUsers.fulfilled]: (state, action) => {
        state.status = 'Fulfilled';
        state.data = action.payload;
      },

      [getUsers.rejected]: (state) => {
        state.status = 'Rejected';
      }
    }
});

export default usersSlice.reducer;